import React from 'react';
import { Box } from '../../../../Box';
import { EmptyResults } from '../../../../EmptyResults/EmptyResults';
import { dataTableClassnames } from '../../const/classNames';

export const NoResults: React.FC = () => {
  return (
    <Box className={dataTableClassnames.table.noResults.root}>
      <EmptyResults width={300} />
    </Box>
  );
};
